package top.wcpe.allincore.ui.runtime.ir.prop

import top.wcpe.allincore.ui.runtime.element.EntityPreview
import top.wcpe.allincore.ui.runtime.element.Slot
import top.wcpe.allincore.ui.runtime.internal.log.UiLog
import top.wcpe.allincore.ui.runtime.ir.eval.ValueCoercion
import kotlin.jvm.JvmStatic

/**
 * EntityPreview 元素属性贡献者。
 *
 * 本贡献者注册的 `scale / rotationX / rotationY` 仅作用于 3D 实体模型自身，
 * 不要与 [TransformPropContributor] 注册的 UI 通用变换属性互混。
 */
@Suppress("CyclomaticComplexMethod", "LongMethod")
internal object EntityPreviewPropContributor {

    private val LOGGER = UiLog("top.wcpe.allincore.ui.runtime.ir.prop.EntityPreviewPropContributor")

    @JvmStatic
    fun contribute(m: MutableMap<String, PropBinding>) {
        m.put(
            "source",
            PropBinding.writeOnly { el, v ->
                if (v == null) return@writeOnly
                if (el is EntityPreview) {
                    el.source(v.toString())
                } else if (el is Slot) {
                    el.groupId(v.toString())
                } else {
                    PropDiag.unsupported(LOGGER, el, "source")
                }
            },
        )
        m.put(
            "visible",
            PropBinding.writeOnly { el, v ->
                if (v == null) return@writeOnly
                val b = ValueCoercion.toBool(v)
                el.visible(b)
                if (el is EntityPreview) {
                    el.visible(b)
                }
            },
        )
        m.put(
            "followMouse",
            PropBinding.writeOnly { el, v ->
                if (v == null) return@writeOnly
                if (el is EntityPreview) {
                    el.followMouse(ValueCoercion.toBool(v))
                } else {
                    PropDiag.unsupported(LOGGER, el, "followMouse")
                }
            },
        )
        m.put(
            "entityType",
            PropBinding.writeOnly { el, v ->
                if (el is EntityPreview) {
                    el.entityType(v?.toString())
                } else {
                    PropDiag.unsupported(LOGGER, el, "entityType")
                }
            },
        )
        m.put(
            "entityName",
            PropBinding.writeOnly { el, v ->
                if (el is EntityPreview) {
                    el.entityName(v?.toString())
                } else {
                    PropDiag.unsupported(LOGGER, el, "entityName")
                }
            },
        )
        m.put(
            "scale",
            PropBinding.writeOnly { el, v ->
                if (v == null) return@writeOnly
                if (el is EntityPreview) {
                    el.scale(ValueCoercion.toFloat(v))
                } else {
                    PropDiag.unsupported(LOGGER, el, "scale")
                }
            },
        )
        m.put(
            "rotationX",
            PropBinding.writeOnly { el, v ->
                if (v == null) return@writeOnly
                if (el is EntityPreview) {
                    el.rotationX(ValueCoercion.toFloat(v))
                } else {
                    PropDiag.unsupported(LOGGER, el, "rotationX")
                }
            },
        )
        m.put(
            "rotationY",
            PropBinding.writeOnly { el, v ->
                if (v == null) return@writeOnly
                if (el is EntityPreview) {
                    el.rotationY(ValueCoercion.toFloat(v))
                } else {
                    PropDiag.unsupported(LOGGER, el, "rotationY")
                }
            },
        )
        m.put(
            "lookAt",
            PropBinding.writeOnly { el, v ->
                if (v == null) return@writeOnly
                if (el is EntityPreview) {
                    el.followMouse(ValueCoercion.toBool(v))
                } else {
                    PropDiag.unsupported(LOGGER, el, "lookAt")
                }
            },
        )
    }
}
